/**
 * meta-tracking.js — fado-theme
 * Meta Pixel event tracking for theme pages.
 *
 * Events fired:
 *   ViewContent  — product pages (on load)
 *   AddToCart    — quick-add + form-submit (on cart:added)
 *
 * InitiateCheckout, Purchase, and CAPI are handled in the
 * Shopify Web Pixels custom extension (Shopify Admin > Settings > Customer events).
 *
 * Depends on:
 *   - fbq() loaded by snippets/meta-pixel.liquid
 *   - cart:added custom event dispatched by assets/fado-theme.js
 */

(function () {
  'use strict';

  if (typeof fbq !== 'function') return;

  // ------------------------------------------------------------------
  // Utility: unique event ID for Meta deduplication
  // ------------------------------------------------------------------
  function generateEventId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  // ------------------------------------------------------------------
  // Utility: active currency
  // ------------------------------------------------------------------
  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active
      : 'INR';
  }

  // ------------------------------------------------------------------
  // ViewContent — fires on product pages only
  // ------------------------------------------------------------------
  function fireViewContent() {
    var productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    var variant = product.variants && product.variants[0];
    var price = variant ? (variant.price / 100).toFixed(2) : '0.00';
    var eventId = generateEventId();

    fbq('track', 'ViewContent', {
      content_ids: [String(product.id)],
      content_type: 'product',
      content_name: product.title,
      content_category: product.product_type || '',
      value: parseFloat(price),
      currency: getCurrency()
    }, { eventID: eventId });
  }

  // ------------------------------------------------------------------
  // AddToCart — fires when fado-theme.js dispatches cart:added
  // ------------------------------------------------------------------
  function initAddToCartTracking() {
    document.addEventListener('cart:added', function (e) {
      var detail = e.detail;
      if (!detail) return;

      var price = detail.price ? (detail.price / 100).toFixed(2) : '0.00';
      var qty = detail.quantity || 1;
      var eventId = generateEventId();

      fbq('track', 'AddToCart', {
        content_ids: [String(detail.variantId)],
        content_type: 'product',
        content_name: detail.productTitle || '',
        value: parseFloat(price) * qty,
        currency: getCurrency(),
        num_items: qty
      }, { eventID: eventId });
    });
  }

  // ------------------------------------------------------------------
  // Init
  // ------------------------------------------------------------------
  fireViewContent();
  initAddToCartTracking();

})();
